import { resolveImagePath } from '@/utils/imageResolver';

interface ServiceItem {
  icon: string;
  title: string;
}

const services: ServiceItem[] = [
  {
    icon: '/wp-content/uploads/2024/10/c38ada61-5332-4334-ae93-c7af4e4ea3ca.png',
    title: 'Annual/100Hr Inspection'
  },
  {
    icon: '/wp-content/uploads/2024/10/6b87c998-6fad-4f03-aa51-9413830e4182.png',
    title: 'Phase Maintenance'
  },
  {
    icon: '/wp-content/uploads/2024/10/avionics-icon1.png',
    title: 'Avionics Services'
  },
  {
    icon: '/wp-content/uploads/2024/10/9e267b6d-0142-4754-990c-5cae450903cb.png',
    title: 'Helicopter Maintenance'
  }
];

export function Services() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src={resolveImagePath(service.icon)}
                  alt="Service icon"
                  className="w-16 h-16 object-contain"
                />
              </div>
              <h4 className="text-lg font-semibold text-gray-800">
                {service.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}